//import logo from './logo.svg';
import './App.css';
// import Head from './components/head/Head';
// import Main01 from './components/main_1/Main01';
// import Main02 from './components/main_2/Main02';
function App() {
  return (
    <div className="App">
    <img src={process.env.PUBLIC_URL + "fox.png"}  alt=''/>
    </div>
  );
}

export default App;
